export function HInvestmentsIcon({
  className,
}: {
  className?: string;
}): JSX.Element {
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M3.93167 15.318V13.895H0.444336V12.8694H7.41867V8.49737H1.32367C1.10078 8.49737 0.898447 8.4097 0.716669 8.23437C0.535114 8.05881 0.444336 7.84481 0.444336 7.59237V2.9207C0.444336 2.66803 0.527669 2.45959 0.694336 2.29537C0.861003 2.13092 1.06822 2.0487 1.316 2.0487H3.93167V0.651367H4.957V2.0487H8.44434V3.07437H1.47V7.4717H7.565C7.81011 7.4717 8.018 7.55381 8.18867 7.71803C8.35911 7.88203 8.44434 8.09315 8.44434 8.35137V13.023C8.44434 13.271 8.36222 13.4784 8.198 13.645C8.03356 13.8117 7.82511 13.895 7.57267 13.895H4.957V15.318H3.93167ZM13.0443 23.0617L8.30067 18.318L9.034 17.5847L13.0443 21.595L20.8393 13.8L21.5727 14.5334L13.0443 23.0617Z" />
    </svg>
  );
}
